var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1TellUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    fill: "#F5D000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 37L36 32L47 37L58 32V58L47 63L36 58L25 63V37Z",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32V58M47 37V63",
    stroke: "black",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 51.9999C32 48.9999 34 48.9999 36 49.9999M47 47.9999C51 44.9999 54 44.9999 58 45.9999",
    stroke: "black",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25H62C64.21 25 66 26.79 66 29V38C66 40.21 64.21 42 62 42H58L53 46V42C50.79 42 49 40.21 49 38V29C49 26.79 50.79 25 53 25Z",
    fill: "#F5D000",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35C55.8284 35 56.5 34.3284 56.5 33.5C56.5 32.6716 55.8284 32 55 32C54.1716 32 53.5 32.6716 53.5 33.5C53.5 34.3284 54.1716 35 55 35Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 35C61.3284 35 62 34.3284 62 33.5C62 32.6716 61.3284 32 60.5 32C59.6716 32 59 32.6716 59 33.5C59 34.3284 59.6716 35 60.5 35Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1TellUs);
export default __webpack_public_path__ + "static/media/step-1-tell-us.8aa7601ec403f34303e0afc5021fc4af.svg";
export { ForwardRef as ReactComponent };